/**
 * Created by luoyunjiao on 17/2/6.
 */

// import Vue from 'vue';

let vue;

const Service = {
    created() {
        vue.util.defineReactive(this, '$validator', {
            $all: (scope) => Object.keys(this.$validator).filter((key) => key.indexOf('$') === -1 && (!scope ? true : this.$validator[key].scope === scope)).map((key) => {
                const message = this.$validator[key].val();
                return message || '';
            }).filter((msg) => msg !== ''),
            $errorMessage: (msgArr, prefix = '以下信息有误: ') => {
                const uniqueMsgArr = [];
                for (let i = 0; i < msgArr.length; i++) {
                    if (msgArr[i] && uniqueMsgArr.indexOf(msgArr[i]) === -1) {
                        uniqueMsgArr.push(msgArr[i]);
                    }
                }
                const parsedMsg = uniqueMsgArr.map((item, index) => `${index + 1} ) ${item}`).join(' \n ');

                return prefix + parsedMsg;
            },
        });
    },
};

export default {
    // mixin: Service,
    // eslint-disable-next-line no-unused-vars
    install(Vue, options) {
        // 定义全局validate
        vue = Vue;
        Vue.options = Vue.util.mergeOptions(Vue.options, Service);
    },
};
